module.exports = __webpack_public_path__ + "4a814cfb527650588c515954f87bb8d2.pdf";